import _ from 'lodash'
import store from '@/store/store'

let transformPlagiarismPerPage = (similarityGroup) => {
  const similarities = store.getters['docRes/plagiarism/getAllSimilarities']

  let dataPlagiarismPerPage = {}
  for (const groupId in similarityGroup) {
    const group = similarityGroup[groupId]
    // let isIgnoredBySystem = false
    // let ignoredBySystemReason = ''
    for (const partId in group.parts) {
      const newElement = {}
      const part = group.parts[partId]
      let highlights = []
      if (group.isIgnored || group.isIgnoredBySystem) {
        console.log('ignored', similarities, group, partId)
        highlights = part.highlights
      } else {
        let similarity = JSON.parse(JSON.stringify(similarities[part.similarityId]))
        if (part.startWordId != similarity.highlights[0].startWordId) {
          const prevPart = group.parts[partId - 1]
          if (prevPart) {
            const prevSimilarity = similarities[prevPart.similarityId]
            similarity.highlights[0].left =
              prevSimilarity.highlights[prevSimilarity.highlights.length - 1].startWordId +
              prevSimilarity.highlights[prevSimilarity.highlights.length - 1].width
          }
        }
        if (part.endWordId != similarity.highlights[similarity.highlights.length - 1].endWordId) {
          const nextPart = group.parts[partId + 1]
          if (nextPart) {
            const nextSimilarity = similarities[nextPart.similarityId]
            similarity.highlights[similarity.highlights.length - 1].width =
              nextSimilarity.highlights[0].startWordId - similarity.highlights[similarity.highlights.length - 1].left
          }
        }
        highlights = similarity.highlights
      }

      highlights.forEach((highlight) => {
        const pageId = highlight.pageId
        if (newElement[pageId]) {
          newElement[pageId].push(highlight)
        } else {
          newElement[pageId] = [highlight]
        }
      })
      for (const page in newElement) {
        const similaritySentenceId = similarities[part.similarityId] ? similarities[part.similarityId].sentenceId : -1
        const sentenceId = part.sentenceId ? part.sentenceId : similaritySentenceId
        let newPart = { ...part, highlights: newElement[page], sentenceId }
        if (dataPlagiarismPerPage[page]) {
          if (dataPlagiarismPerPage[page].groups[group.id]) {
            dataPlagiarismPerPage[page].groups[group.id].parts.push(newPart)
          } else {
            dataPlagiarismPerPage[page].groups[group.id] = { ...group, parts: [newPart] }
          }
        } else {
          dataPlagiarismPerPage[page] = { groups: {} }
          dataPlagiarismPerPage[page].groups[group.id] = { ...group, parts: [newPart] }
        }
      }
    }
  }

  let dataPlagiarismByPage = _(dataPlagiarismPerPage)
    .map((value, key) => ({ pageId: parseInt(key), groups: value.groups }))
    .value()
  return dataPlagiarismByPage
}

let combineDataPerPage = (data_images, data_plagiarism, data_spelling) => {
  let data_combine_pages = []
  for (let index = 0; index < data_images.length; index++) {
    let pageId = index + 1
    let data_plagiarism_page = []
    let data_spelling_page = []
    let data_image = data_images[index]

    let data_plagiarism_find = _.find(data_plagiarism, { pageId: pageId })
    let data_spelling_find = _.find(data_spelling, { page: String(pageId) })

    if (data_plagiarism_find != null && data_plagiarism_find['groups'] != null) {
      data_plagiarism_page = data_plagiarism_find['groups']
    }

    if (data_spelling_find != null && data_spelling_find['mistakes'] != null) {
      data_spelling_page = data_spelling_find['mistakes']
    }
    let data_combine_page = {
      pageId: pageId,
      data_image: data_image,
      data_plagiarism: data_plagiarism_page,
      data_spelling: data_spelling_page,
    }
    data_combine_pages.push(data_combine_page)
  }
  // console.log(data_combine_pages)
  return data_combine_pages
}

export { transformPlagiarismPerPage, combineDataPerPage }
